/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { Button, Form, Select, InputNumber, DatePicker, Card, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../../../components/Header';
import Sidebar from '../../../components/Sidebar';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { ActionGetRoomTypeOptions } from '../../../store/Actions/MasterDataAction';
import { ActionGetOccupancyModeOptions } from '../../../store/Actions/occupancyAction';
import { ActionCreateRoomPrice } from '../../../store/Actions/RoomPriceAction';
import dayjs from 'dayjs';

const AddRoomPrices = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const { roomTypeOptions } = useSelector(state => state?.MasterData);
    const { occupancyOptions } = useSelector(state => state?.OccupancyManagement);

    useEffect(() => {
        dispatch(ActionGetRoomTypeOptions({ Query: '?action=get_options' }));
        dispatch(ActionGetOccupancyModeOptions({ Query: '?action=get_options' }));
    }, [dispatch]);

    const onFinish = (values) => {
        setLoading(true);
        const payload = {
            ...values,
            validFrom: values.validFrom.format('YYYY-MM-DD'),
        };

        dispatch(ActionCreateRoomPrice(payload, (res) => {
            setLoading(false);
            if (res) {
                message.success('Room price created successfully');
                navigate('/room-prices');
            } else {
                message.error('Failed to create room price');
            }
        }));
    };

    return (
        <>
            <Header />
            <Sidebar />
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/room-prices">Room Prices</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <i className="feather-chevron-right">
                                            <FeatherIcon icon="chevron-right" />
                                        </i>
                                    </li>
                                    <li className="breadcrumb-item active">Add Room Price</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <Card title="Add New Room Price">
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={onFinish}
                                    initialValues={{
                                        currency: 'INR',
                                        validFrom: dayjs('2025-12-30'),
                                    }}
                                >
                                    <div className="row">
                                        {/* <div className="col-12">
                                            <pre style={{ maxHeight: '200px', overflow: 'auto', background: '#f0f0f0', padding: '10px' }}>
                                                {JSON.stringify(roomTypeOptions, null, 2)}
                                            </pre>
                                        </div> */}
                                        <div className="col-12 col-md-6 col-xl-6">
                                            <Form.Item
                                                name="roomTypeId"
                                                label="Room Type"
                                                rules={[{ required: true, message: 'Please select room type' }]}
                                            >
                                                <Select
                                                    placeholder="Select Room Type"
                                                    showSearch
                                                    filterOption={(input, option) =>
                                                        (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                                    }
                                                >
                                                    {roomTypeOptions?.map((item, index) => {
                                                        const val = item.value || item.id || item._id;
                                                        return (
                                                            <Select.Option key={index} value={String(val)}>
                                                                {item.label || item.name}
                                                            </Select.Option>
                                                        );
                                                    })}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                        <div className="col-12 col-md-6 col-xl-6">
                                            <Form.Item
                                                name="occupancyModeId"
                                                label="Occupancy Mode"
                                                rules={[{ required: true, message: 'Please select occupancy mode' }]}
                                            >
                                                <Select
                                                    placeholder="Select Occupancy Mode"
                                                    showSearch
                                                    filterOption={(input, option) =>
                                                        (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                                    }
                                                >
                                                    {occupancyOptions?.map((item, index) => {
                                                        const val = item.value || item.id || item._id;
                                                        return (
                                                            <Select.Option key={index} value={String(val)}>
                                                                {item.label || item.name}
                                                            </Select.Option>
                                                        );
                                                    })}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                        <div className="col-12 col-md-6 col-xl-4">
                                            <Form.Item
                                                name="pricePerDay"
                                                label="Price Per Day"
                                                rules={[{ required: true, message: 'Please enter price' }]}
                                            >
                                                <InputNumber
                                                    style={{ width: '100%' }}
                                                    min={0}
                                                    placeholder="Enter Price"
                                                />
                                            </Form.Item>
                                        </div>
                                        <div className="col-12 col-md-6 col-xl-4">
                                            <Form.Item
                                                name="perDayPriceForCaretaker"
                                                label="Caretaker Price Per Day"
                                                rules={[{ required: false, message: 'Please enter caretaker price' }]}
                                            >
                                                <InputNumber
                                                    style={{ width: '100%' }}
                                                    min={0}
                                                    placeholder="Enter Caretaker Price"
                                                />
                                            </Form.Item>
                                        </div>
                                        <div className="col-12 col-md-6 col-xl-4">
                                            <Form.Item
                                                name="currency"
                                                label="Currency"
                                                rules={[{ required: true, message: 'Please select currency' }]}
                                            >
                                                <Select placeholder="Select Currency">
                                                    <Select.Option value="INR">INR</Select.Option>
                                                    <Select.Option value="USD">USD</Select.Option>
                                                </Select>
                                            </Form.Item>
                                        </div>
                                        <div className="col-12 col-md-6 col-xl-4">
                                            <Form.Item
                                                name="validFrom"
                                                label="Valid From"
                                                rules={[{ required: true, message: 'Please select date' }]}
                                            >
                                                <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="doctor-submit text-end">
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    loading={loading}
                                                    className="btn btn-primary submit-form me-2"
                                                >
                                                    Submit
                                                </Button>
                                                <Button
                                                    type="default"
                                                    onClick={() => navigate('/room-prices')}
                                                    className="btn btn-primary cancel-form"
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddRoomPrices;